import {
  ENGLISH_PREFRENCE,
  NO_PREFRENCE,
  HINDI_PREFRENCE
} from '@constants/quiz';

function getContent(content) {
  return (
    content[ENGLISH_PREFRENCE.code] ||
    content[NO_PREFRENCE.code] ||
    content[HINDI_PREFRENCE.code] ||
    content[
      Object.keys(content)[0]
    ] /* Returns the first value in the content object if no default code(English,Hindi,No preference) is present in the content */
  );
}
export default getContent;
